<template>
  <div
    :class="[
      fixed
        ? `
          sticky top-0 z-10 border-b border-border bg-muted/70 shadow-sm backdrop-blur
          supports-[backdrop-filter]:bg-muted/60
        `
        : 'border-b border-border bg-muted/40',
    ]"
  >
    <div class="flex items-center gap-2 bg-secondary px-4 pb-1 pt-2">
      <div
        v-if="$slots.leftAction"
        class="flex items-center gap-2"
      >
        <slot name="leftAction"></slot>
      </div>
      <div
        v-if="$slots.topRight || showClose"
        class="ml-auto flex items-center gap-2"
      >
        <slot name="topRight"></slot>
        <button
          v-if="showClose"
          type="button"
          class="
            inline-flex size-8 items-center justify-center rounded-md
            hover:bg-muted/60
          "
          @click="emit('close')"
        >
          <X class="size-4" />
        </button>
      </div>
    </div>

    <div class="bg-secondary px-4 pb-2 pt-1">
      <div class="flex items-center justify-between gap-3">
        <!-- Allow complete customization of header content (e.g., for select/dropdown) -->
        <slot name="headerContent">
          <div class="flex items-center gap-3">
            <slot name="icon">
              <div
                v-if="icon"
                class="rounded-full bg-foreground p-2 text-primary-foreground"
              >
                <component
                  :is="icon"
                  class="size-4"
                />
              </div>
            </slot>
            <div>
              <!-- Allow custom title component via slot for accessibility (e.g., SheetTitle) -->
              <slot name="titleWrapper">
                <component
                  :is="titleTag"
                  class="text-base font-semibold leading-none"
                >
                  <slot name="title">{{ title }}</slot>
                </component>
              </slot>
              <!-- Custom subtitle slot for accessibility (e.g., SheetDescription) -->
              <slot
                v-if="subtitle || $slots.subtitle || $slots.subtitleWrapper"
                name="subtitleWrapper"
              >
                <p class="text-xs italic opacity-70">
                  <slot name="subtitle">{{ subtitle }}</slot>
                </p>
              </slot>
            </div>
          </div>
        </slot>
        <div
          v-if="$slots.rightAction"
          class="flex items-center gap-2"
        >
          <slot name="rightAction"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { type Component } from 'vue'

import { X } from 'lucide-vue-next'

withDefaults(
  defineProps<{
    icon?: Component
    title?: string
    subtitle?: string
    showClose?: boolean
    fixed?: boolean
    titleTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span'
  }>(),
  {
    titleTag: 'h2',
  },
)

const emit = defineEmits<{
  (e: 'close'): void
}>()
</script>
